import { render, staticRenderFns } from "./OrganizationGrid.vue?vue&type=template&id=99a61cbc"
import script from "./OrganizationGrid.vue?vue&type=script&lang=js"
export * from "./OrganizationGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports